module.exports = __webpack_public_path__ + "img/b2binpay-otm.f71f26ab.svg";